// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'react-datepicker';
import AddCompetitionGallery from '../addCompetitionGallery';
import FlatButton from 'material-ui/FlatButton';
import { colors, btn, card, empty } from '../../../../style/common/partnerStyle';

class ViewCompetitionGallery extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      competition_id: props.competition_id,
      album_list: [],
      data_uploaded: false,
      data_error: false,
      addExpenseView: false,
      billView: false,
      bill_source: '',
      add_photos_visible: false,
      to_delete_album: false,
      hovered_album: null,   // index of card being hovered
      selected_album: {
        album_id: null,
        album_name: '',
        cover_photo: '',
      },
    };
    this.getGalleryDetail = this.getGalleryDetail.bind(this);
    this.ParentCallback   = this.ParentCallback.bind(this);
    this.deleteAlbums     = this.deleteAlbums.bind(this);
  }

  componentDidMount() { this.getGalleryDetail(); }

  ParentCallback() {
    this.setState({ add_photos_visible: false });
    this.getGalleryDetail();
  }

  getGalleryDetail() {
    const url = `${getLocationOrigin()}/tournament/get_albums/?competition_id=${this.state.competition_id}`;
    const options = {...defaultOptions};
    options['method'] = 'get';
    options['headers'] = { 'content-type': 'application/json' };
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => this.setState({ album_list: data.albums }))
      .catch(error => { console.log(error); alert(error.message); });
  }

  onViewBill(bill_source) { this.setState({ billView: !this.state.billView, bill_source: bill_source }); }

  edit_album(album) {
    if (album) this.setState({ add_photos_visible: true, selected_album: album });
    else       this.setState({ add_photos_visible: true });
  }

  add_new_album() {
    this.setState({ add_photos_visible: true, selected_album: { album_id: null, album_name: '', cover_photo: '' } });
  }

  deleteAlbums(album_id) {
    event.preventDefault();
    if (confirm("Are you sure you want delete?") == true) {
      this.setState({ to_delete_album: true });
      const url = `${getLocationOrigin()}/tournament/delete_albums/?album_id=${album_id}`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = { 'content-type': 'application/json' };
      options['body'] = JSON.stringify({ competition_id: this.state.competition_id, album_id: album_id });
      return fetch(url, options)
        .then(checkStatus).then(parseJSON)
        .catch(error => { alert(error.message); this.setState({ to_delete_album: false }); })
        .then(data => { alert(data.message); this.setState({ to_delete_album: false }); window.location.reload(); });
    }
    else { this.setState({ add_photos_visible: false }); }
  }

  renderGallery() {
    const { album_list, hovered_album } = this.state;

    return (
      <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif" }}>

        {/* Header */}
        <div style={card.header}>
          <div>
            <h2 style={card.title}>
              Gallery
              {album_list.length > 0 && <span style={card.titleCount}>{album_list.length} album{album_list.length > 1 ? 's' : ''}</span>}
            </h2>
          </div>
          <button style={btn.primary} onClick={() => { this.add_new_album(); }}>+ New Album</button>
        </div>

        {album_list.length > 0 ? (
          <div style={{ padding: '20px 24px' }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))',
              gap: 16,
            }}>
              {album_list.map((album, index) => (
                <div
                  key={index}
                  style={{
                    borderRadius: 12,
                    overflow: 'hidden',
                    background: colors.surface,
                    boxShadow: hovered_album === index
                      ? '0 4px 20px rgba(0,0,0,0.14), 0 1px 6px rgba(0,0,0,0.08)'
                      : '0 1px 4px rgba(0,0,0,0.07), 0 2px 10px rgba(0,0,0,0.05)',
                    cursor: 'pointer',
                    position: 'relative',
                    transition: 'box-shadow 0.18s, transform 0.18s',
                    transform: hovered_album === index ? 'translateY(-2px)' : 'none',
                  }}
                  onClick={() => { this.edit_album(album); }}
                  onMouseEnter={() => this.setState({ hovered_album: index })}
                  onMouseLeave={() => this.setState({ hovered_album: null })}
                >
                  {/* Cover photo */}
                  <div style={{ position: 'relative', width: '100%', paddingTop: '70%', background: colors.bg, overflow: 'hidden' }}>
                    {album.cover_photo && album.cover_photo.image ? (
                      <img
                        src={album.cover_photo.image}
                        alt={album.name}
                        style={{
                          position: 'absolute', inset: 0,
                          width: '100%', height: '100%',
                          objectFit: 'cover', display: 'block',
                          transition: 'transform 0.25s',
                          transform: hovered_album === index ? 'scale(1.04)' : 'scale(1)',
                        }}
                      />
                    ) : (
                      /* Placeholder when no cover photo */
                      <div style={{
                        position: 'absolute', inset: 0,
                        display: 'flex', flexDirection: 'column',
                        alignItems: 'center', justifyContent: 'center',
                        background: `linear-gradient(135deg, ${colors.brandLt} 0%, #e0e7ff 100%)`,
                        gap: 6,
                      }}>
                        <span style={{ fontSize: 30 }}>🖼️</span>
                        <span style={{ fontSize: 11, color: colors.brand, fontWeight: 600 }}>No cover</span>
                      </div>
                    )}

                    {/* Dark gradient overlay at bottom for label legibility */}
                    <div style={{
                      position: 'absolute', left: 0, right: 0, bottom: 0, height: '45%',
                      background: 'linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 100%)',
                      pointerEvents: 'none',
                    }} />

                    {/* Delete button */}
                    <button
                      style={{
                        position: 'absolute', top: 8, right: 8,
                        width: 26, height: 26, borderRadius: '50%',
                        background: 'rgba(0,0,0,0.45)', color: '#fff',
                        border: '1.5px solid rgba(255,255,255,0.5)',
                        cursor: 'pointer', fontSize: 14, fontWeight: 700,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontFamily: 'inherit', lineHeight: 1,
                        transition: 'background 0.15s',
                        opacity: hovered_album === index ? 1 : 0.6,
                      }}
                      title="Delete album"
                      onClick={e => {
                        e.stopPropagation();
                        this.setState({ add_photos_visible: false });
                        this.deleteAlbums(album.id);
                      }}
                      onMouseEnter={e => { e.currentTarget.style.background = 'rgba(224,36,36,0.85)'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = 'rgba(0,0,0,0.45)'; }}
                    >×</button>
                  </div>

                  {/* Album name + meta */}
                  <div style={{ padding: '10px 12px 12px' }}>
                    <div style={{
                      fontSize: 13, fontWeight: 700, color: colors.text,
                      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                      marginBottom: 2,
                    }}>
                      {album.name}
                    </div>
                    {album.photo_count != null && (
                      <div style={{ fontSize: 11, color: colors.muted }}>
                        {album.photo_count} photo{album.photo_count !== 1 ? 's' : ''}
                      </div>
                    )}
                  </div>
                </div>
              ))}

              {/* ── Add new album card ── */}
              <div
                style={{
                  borderRadius: 12,
                  border: `2px dashed ${hovered_album === 'new' ? colors.brand : colors.border}`,
                  background: hovered_album === 'new' ? colors.brandLt : 'transparent',
                  cursor: 'pointer',
                  display: 'flex', flexDirection: 'column',
                  alignItems: 'center', justifyContent: 'center',
                  gap: 8, minHeight: 170,
                  transition: 'border-color 0.18s, background 0.18s',
                }}
                onClick={() => { this.add_new_album(); }}
                onMouseEnter={() => this.setState({ hovered_album: 'new' })}
                onMouseLeave={() => this.setState({ hovered_album: null })}
              >
                <span style={{ fontSize: 28, lineHeight: 1 }}>+</span>
                <span style={{ fontSize: 13, fontWeight: 600, color: hovered_album === 'new' ? colors.brand : colors.muted }}>New Album</span>
              </div>
            </div>
          </div>
        ) : (
          <div style={empty.wrap}>
            <div style={empty.icon}>🖼️</div>
            <div style={empty.title}>No Albums Yet</div>
            <div style={empty.text}>Click "+ New Album" to create your first album.</div>
          </div>
        )}
      </div>
    );
  }

  render() {
    const okaction = <input type="button" className="button1" value="OK" onClick={() => { this.onViewBill(); }} />;

    return (
      <div>
        {!this.state.add_photos_visible && this.renderGallery()}
        {this.state.add_photos_visible &&
          <AddCompetitionGallery
            competition_id={this.state.competition_id}
            album={this.state.selected_album}
            ParentCallback={this.ParentCallback}
          />
        }
      </div>
    );
  }
}

export default ViewCompetitionGallery;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetitionGallery/index.js